// React
import React from 'react';
// componentes
import Modal from 'components/CustomDialog';
import { Container, Grid} from '@material-ui/core';
import {useStyles} from './style';

const  MostrarInformeGeneradoModal= (props)=> {
        const classes = useStyles();

        return (
            <Modal 
                open={props.open}
                fullScreen={props.fullScreen}
                closeModal={props.closeModal}
                iconToolbar={props.iconToolbar}
                titleToolbar={props.titleToolbar}
            >
                <Container maxWidth="lg" className={classes.container}>        
                    <Grid container className={classes.gridPrincipal}>
                        <Grid className={classes.gridIframe} item xs={12} container direction="row" justifyContent="center" alignItems="center">
                            <iframe title="Informe" width="100%" height="100%" src={`data:application/pdf;base64,${props.base64}`} frameborder="0" allowFullScreen="false"></iframe>
                        </Grid>
                    </Grid>
                </Container>
            </Modal>
        )
}
export default MostrarInformeGeneradoModal;